import { ReducerAction, ReducerActionWithPayload } from '../../App.types';
import { createReducer } from '../../helpers';
import { Currency } from '@round/api';

export type CreatorbaseCurrencyContextState = {
    currencies: Currency[];
    isLoading: boolean;
    error: string | null;
};

export type CreatorbaseCurrencyContextActions =
    | ReducerActionWithPayload<'currenciesLoaded', Currency[]>
    | ReducerAction<'loadingStarted'>
    | ReducerActionWithPayload<'error', string | null>;

export const initialState: CreatorbaseCurrencyContextState = {
    currencies: [],
    isLoading: false,
    error: null,
};

export default createReducer<CreatorbaseCurrencyContextState, CreatorbaseCurrencyContextActions>({
    currenciesLoaded: (state, { payload }) => ({
        ...state,
        currencies: payload,
        isLoading: false,
        error: null,
    }),
    loadingStarted: (state) => ({
        ...state,
        isLoading: true,
        error: null,
    }),
    error: (state, { payload }) => ({
        ...state,
        isLoading: false,
        error: payload,
    }),
});
